import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';
import SharedProgrammeDetailedPreviewContent from './shared_programme_detailed_preview_content';
import { trackEvents } from '../../operations/tracking_operations';
// import { showGlobalSnackbar } from '../../features/global_snackbar/global_snackbar_slice';
import { useGetSharedProgrammeQuery } from '../../app/smorgAppSyncGraphQLApi';
import { sharedProgrammeDurationDays } from '../../services/programmes';
import { calendarDayFromJSDate } from '../../services/dates';
import { isProgrammeEnrollmentCompleted } from '../../services/my_day';
import { useCurrentProgrammeEnrollmentQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';
// import { currentUserAccessibleMembershipTierIDsSelector } from '../../reducers/user_reducer';

const SharedProgrammeStartPage = ({ sharedProgrammeId }) => {
  // const dispatch = useDispatch();

  const today = calendarDayFromJSDate(new Date());

  const navigate = useNavigate();

  const { data: sharedProgramme } = useGetSharedProgrammeQuery(
    sharedProgrammeId,
    {
      skip: !sharedProgrammeId,
      refetchOnMountOrArgChange: SHARED_PROGRAMMES_REFRESH_INTERVAL_SECONDS,
    },
  );

  // const accessibleMembershipTierIDs = useSelector(
  //   currentUserAccessibleMembershipTierIDsSelector,
  // );

  const needsMembershipUpgrade = false; /*
    !sharedProgramme.availableInMembershipTierIDs ||
    sharedProgramme.availableInMembershipTierIDs.every(
      (mtid) => !accessibleMembershipTierIDs.includes(mtid),
    ) */

  const { data: currentProgrammeEnrollment } =
    useCurrentProgrammeEnrollmentQuery();

  const isEnrolled =
    currentProgrammeEnrollment?.sharedProgrammeID === sharedProgrammeId;

  const isCompleted =
    isEnrolled &&
    isProgrammeEnrollmentCompleted(
      currentProgrammeEnrollment,
      sharedProgrammeDurationDays(sharedProgramme),
      today,
    );

  // const programmeEnrollmentID = useSelector(
  //   (state) => currentProgrammeEnrollmentSelector(state)?.id,
  // );

  const onBack = () => {
    navigate(-1);
  };

  const onStartProgram = () => {
    trackEvents([
      {
        name: 'Program started',
        args: {
          program_name: sharedProgramme.title,
          space_id: sharedProgramme.spaceId,
          program_id: sharedProgrammeId,
        },
      },
    ]);
    navigate(`/shared_programmes/${sharedProgrammeId}/onboard`);
  };

  if (!sharedProgramme) {
    return null;
  }

  return (
    <div className="sharedProgrammeStartPage">
      <Grid
        container
        alignContent="start"
        style={{
          height: 'calc(var(--app-height) - 55px)',
          overflowY: 'scroll',
        }}>
        <SharedProgrammeDetailedPreviewContent
          title={sharedProgramme.title}
          shortDescription={sharedProgramme.shortDescription}
          description={sharedProgramme.description}
          coverImageUrl={sharedProgramme.coverImageUrl}
          onBack={onBack}
        />
      </Grid>
      <div
        style={{
          width: '100%',
          display: 'flex',
        }}>
        {!isEnrolled && (
          <Button
            onClick={(ev) => {
              ev.preventDefault();
              onStartProgram();
            }}
            variant="contained"
            size="medium"
            disableElevation
            style={{ borderRadius: '30px', margin: '0 auto' }}>
            {needsMembershipUpgrade && (
              <>
                <LockIcon />
                Upgrade your membership
              </>
            )}
            {!needsMembershipUpgrade && 'Start this program'}
          </Button>
        )}
        {isEnrolled && isCompleted && (
          <Button
            onClick={(ev) => {
              ev.preventDefault();
              onStartProgram();
            }}
            variant="contained"
            size="medium"
            disableElevation
            style={{ borderRadius: '30px', margin: '0 auto' }}>
            Restart this program
          </Button>
        )}
      </div>
    </div>
  );
};

SharedProgrammeStartPage.propTypes = {
  sharedProgrammeId: PropTypes.string.isRequired,
};

export default SharedProgrammeStartPage;
